import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { useMediaQuery } from '@nebula/hooks';

import { StyledTitleLarge500, StyledTitleXLarge500 } from './index.styles';
import { PageTitleContainer } from './pageTitle.styles';

const PageTitle = () => {
  const theme = useContext(ThemeContext);
  const isTabletLandscape = useMediaQuery(theme.media.tabletLandscapeMin);
  const TitleText = isTabletLandscape ? StyledTitleXLarge500 : StyledTitleLarge500;

  return (
    <PageTitleContainer>
      <TitleText as="h1">Review and pay</TitleText>
    </PageTitleContainer>
  );
};

export default PageTitle;
